import { FormikHelpers } from "formik";

export type Address = {
  name: string;
  street1: string;
  street2: string;
  city: string;
  state: string;
  postalCode: string;
};

export enum ShippingKey {
  KIND = "kind",
  CITY = "city",
  NAME = "name",
  POSTAL_CODE = "postalCode",
  STATE = "state",
  STREET1 = "street1",
  STREET2 = "street2",
}
export type ShippingValues = {
  [ShippingKey.KIND]: "shipping";
  [ShippingKey.CITY]: string;
  [ShippingKey.NAME]: string;
  [ShippingKey.POSTAL_CODE]: string;
  [ShippingKey.STATE]: string;
  [ShippingKey.STREET1]: string;
  [ShippingKey.STREET2]: string;
};
export type ShippingSubmit = (
  values: ShippingValues,
  formikHelpers: FormikHelpers<ShippingValues>
) => void;
